import { get, post } from "@/fn/ajax";
import { appId } from "@/store";
import tryParseJson from "@/fn/tryParseJson";
import { mockGet, tid, title20, typeInt, dateRange } from "./mock";
import Mock from "mockjs";

interface LoginData {
  username: string;
  password: string;
}

/**
 * 登录
 * @param data 提交数据
 */
export async function login(data: LoginData) {
  const res = await post("/auth/login", data);
  return res;
}

/**
 * 退出
 */
export async function logout() {
  const res = await post("/auth/logout");
  return res;
}

/**
 * 获取登录用户信息
 */
export async function getUserInfo() {
  const res = await get("/auth/infos");
  return res;
}

/**
 * 获取当前登录用户的菜单列表
 */
export async function getMenuList(id: any) {
  const manageuserId = tryParseJson(localStorage.getItem("user")).id;
  const res = await get("/user/detail", { manageuserId });
  return res;

  // return await Mock.mock({
  //   code: 0,
  //   msg: null,
  //   data: {
  //     manageUser: {
  //       managerUserId: 1,
  //       managerEmail: 'admin',
  //       managerRealName: 'admin',
  //       managerPassword: '21232f297a57a5a743894a0e4a801fc3',
  //       managerStatus: 1,
  //       managerRemark: '管理员',
  //       createTime: 1571331515000,
  //       createUser: 1,
  //       managerRealNameEn: 'adminen',
  //     },
  //     navMap: {
  //       // 1: [
  //       //   {
  //       //     "navigationId": 1,
  //       //     "navigationName": "场馆管理",
  //       //     "navigationUrl": "/dashboard/venues",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 1,
  //       //     "parentId": 0,
  //       //     "createTime": 1571378719000,
  //       //     "createUser": 1,
  //       //     "icon": "dollar",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ],
  //       2: [
  //         {
  //           navigationId: 2,
  //           navigationName: '演出管理',
  //           navigationUrl: '/performance',
  //           navigationSequence: 1,
  //           groupId: 2,
  //           parentId: 0,
  //           createTime: 1571378921000,
  //           createUser: 1,
  //           icon: 'calendar',
  //           isMenu: 1,
  //           isHave: true,
  //           isParent: 1,
  //           have: true,
  //         },
  //         {
  //           navigationId: 21,
  //           navigationName: '演出列表',
  //           navigationUrl: '/performance/management',
  //           navigationSequence: 2,
  //           groupId: 2,
  //           parentId: 2,
  //           createTime: 1573286440000,
  //           createUser: 1,
  //           icon: 'calendar',
  //           isMenu: 1,
  //           isHave: true,
  //           isParent: null,
  //           have: true,
  //         },
  //       ],
  //       // "3": [
  //       //   {
  //       //     "navigationId": 3,
  //       //     "navigationName": "渠道管理",
  //       //     "navigationUrl": "/channel/management",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 3,
  //       //     "parentId": 0,
  //       //     "createTime": 1571378951000,
  //       //     "createUser": 1,
  //       //     "icon": "project",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // "4": [
  //       //   {
  //       //     "navigationId": 4,
  //       //     "navigationName": "票种管理",
  //       //     "navigationUrl": "/ticket/kind",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 4,
  //       //     "parentId": 0,
  //       //     "createTime": 1571378981000,
  //       //     "createUser": 1,
  //       //     "icon": "rocket",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // 6: [
  //       //   {
  //       //     navigationId: 6,
  //       //     navigationName: '用户管理',
  //       //     navigationUrl: '/user/management',
  //       //     navigationSequence: 1,
  //       //     groupId: 6,
  //       //     parentId: 0,
  //       //     createTime: 1571379048000,
  //       //     createUser: 1,
  //       //     icon: 'user',
  //       //     isMenu: 1,
  //       //     isHave: true,
  //       //     isParent: 1,
  //       //     have: true
  //       //   }
  //       // ],
  //       // "7": [
  //       //   {
  //       //     "navigationId": 7,
  //       //     "navigationName": "订单管理",
  //       //     "navigationUrl": "/order/management",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 7,
  //       //     "parentId": 0,
  //       //     "createTime": 1571379075000,
  //       //     "createUser": 1,
  //       //     "icon": "red-envelope",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // "8": [
  //       //   {
  //       //     "navigationId": 8,
  //       //     "navigationName": "票管理",
  //       //     "navigationUrl": "/ticket",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 8,
  //       //     "parentId": 0,
  //       //     "createTime": 1571379110000,
  //       //     "createUser": 1,
  //       //     "icon": "safety",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   },
  //       //   {
  //       //     "navigationId": 9,
  //       //     "navigationName": "票明细",
  //       //     "navigationUrl": "/ticket/management",
  //       //     "navigationSequence": 2,
  //       //     "groupId": 8,
  //       //     "parentId": 8,
  //       //     "createTime": 1571379148000,
  //       //     "createUser": 1,
  //       //     "icon": "barcode",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": null,
  //       //     "have": true
  //       //   },
  //       //   {
  //       //     "navigationId": 10,
  //       //     "navigationName": "票配置",
  //       //     "navigationUrl": "/ticket/config",
  //       //     "navigationSequence": 3,
  //       //     "groupId": 8,
  //       //     "parentId": 8,
  //       //     "createTime": 1571379201000,
  //       //     "createUser": 1,
  //       //     "icon": "exception",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": null,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // "10": [
  //       //   {
  //       //     "navigationId": 12,
  //       //     "navigationName": "秘钥权限",
  //       //     "navigationUrl": "1",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 10,
  //       //     "parentId": 0,
  //       //     "createTime": 1571984708000,
  //       //     "createUser": 1,
  //       //     "icon": "qrcode",
  //       //     "isMenu": 0,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // 11: [
  //       //   {
  //       //     navigationId: 13,
  //       //     navigationName: "权限管理",
  //       //     navigationUrl: "/auth",
  //       //     navigationSequence: 1,
  //       //     groupId: 11,
  //       //     parentId: 0,
  //       //     createTime: 1572078580000,
  //       //     createUser: 1,
  //       //     icon: "tool",
  //       //     isMenu: 1,
  //       //     isHave: true,
  //       //     isParent: 1,
  //       //     have: true,
  //       //   },
  //       //   {
  //       //     navigationId: 14,
  //       //     navigationName: "用户列表",
  //       //     navigationUrl: "/auth/user",
  //       //     navigationSequence: 2,
  //       //     groupId: 11,
  //       //     parentId: 13,
  //       //     createTime: 1572078683000,
  //       //     createUser: 1,
  //       //     icon: "user-add",
  //       //     isMenu: 1,
  //       //     isHave: true,
  //       //     isParent: null,
  //       //     have: true,
  //       //   },
  //       //   {
  //       //     navigationId: 15,
  //       //     navigationName: "权限列表",
  //       //     navigationUrl: "/auth/list",
  //       //     navigationSequence: 3,
  //       //     groupId: 11,
  //       //     parentId: 13,
  //       //     createTime: 1572078685000,
  //       //     createUser: 1,
  //       //     icon: "profile",
  //       //     isMenu: 1,
  //       //     isHave: true,
  //       //     isParent: null,
  //       //     have: true,
  //       //   },
  //       // ],
  //       // "14": [
  //       //   {
  //       //     "navigationId": 20,
  //       //     "navigationName": "兑换码",
  //       //     "navigationUrl": "/activation/code",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 14,
  //       //     "parentId": 0,
  //       //     "createTime": 1573046951000,
  //       //     "createUser": 1,
  //       //     "icon": "qrcode",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // "16": [
  //       //   {
  //       //     "navigationId": 24,
  //       //     "navigationName": "报表管理",
  //       //     "navigationUrl": "/report",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 16,
  //       //     "parentId": 0,
  //       //     "createTime": 1573715447000,
  //       //     "createUser": 1,
  //       //     "icon": "area-chart",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   },
  //       //   {
  //       //     "navigationId": 26,
  //       //     "navigationName": "票种统计",
  //       //     "navigationUrl": "/report/ticketkind",
  //       //     "navigationSequence": 3,
  //       //     "groupId": 16,
  //       //     "parentId": 24,
  //       //     "createTime": 1573715562000,
  //       //     "createUser": 1,
  //       //     "icon": "sliders",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": null,
  //       //     "have": true
  //       //   },
  //       //   {
  //       //     "navigationId": 28,
  //       //     "navigationName": "渠道销售统计",
  //       //     "navigationUrl": "/report/sales",
  //       //     "navigationSequence": 5,
  //       //     "groupId": 16,
  //       //     "parentId": 24,
  //       //     "createTime": 1573715673000,
  //       //     "createUser": 1,
  //       //     "icon": "heat-map",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": null,
  //       //     "have": true
  //       //   },
  //       //   {
  //       //     "navigationId": 29,
  //       //     "navigationName": "场次统计",
  //       //     "navigationUrl": "/report/showtime",
  //       //     "navigationSequence": 6,
  //       //     "groupId": 16,
  //       //     "parentId": 24,
  //       //     "createTime": 1576063920000,
  //       //     "createUser": 1,
  //       //     "icon": "dot-chart",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": null,
  //       //     "have": true
  //       //   }
  //       // ],
  //       // "17": [
  //       //   {
  //       //     "navigationId": 30,
  //       //     "navigationName": "会员权益",
  //       //     "navigationUrl": "/userinfo",
  //       //     "navigationSequence": 1,
  //       //     "groupId": 17,
  //       //     "parentId": 0,
  //       //     "createTime": 1576397281000,
  //       //     "createUser": 1,
  //       //     "icon": "user",
  //       //     "isMenu": 1,
  //       //     "isHave": true,
  //       //     "isParent": 1,
  //       //     "have": true
  //       //   }
  //       // ]
  //     },
  //     manageUserStatusList: [
  //       {
  //         value: '有效',
  //         key: 1,
  //       },
  //       {
  //         value: '无效',
  //         key: 2,
  //       },
  //     ],
  //   },
  // })
}

/**
 * 获取当前登录用户的权限列表
 */
export async function getPermList() {
  const res = await get("/auth/perms/current-user", { appId });
  return res;
}

// 获取用户列表
export async function getUserList(query: any) {
  const res = await get("/user/list", query);
  return res;
}

// 获取后台用户列表
export async function getAdminUserList(query: any) {
  // const res = await get('/admin/user/list', query)
  // return res

  return await Mock.mock({
    code: 0,
    msg: null,
    data: {
      "items|10": [
        {
          manageuserId: 10,
          email: "eComm Test",
          realName: "eComm",
          password: "89ee13f25cabd31e42e064af12a3b185",
          perms: null,
          token: null,
          remark: null,
          createUser: 1,
          createTime: 1579775061000,
          status: 1,
        },
      ],
      manageUserStatusList: [
        {
          value: "有效",
          key: 1,
        },
        {
          value: "无效",
          key: 2,
        },
      ],
      totalCount: 8,
    },
  });
}

// 获取用户详情
export async function getUserDetail(id: any) {
  const res = await get(`/user/detail/${id}`);
  return res;
}

// 更改用户状态
export async function changeUserStatus(id: any, query: any) {
  // const res = await post(`/user/modify/status/${id}`, query)
  // return res

  return await Mock.mock({
    code: 0,
    msg: null,
    data: 10,
  });
}

/**
 * 后台用户列表
 */
export async function userlist(query: any) {
  // const res = await get('/admin/user/list', query)
  // return res

  return await Mock.mock({
    code: 0,
    msg: null,
    data: {
      "items|10": [
        {
          "manageUserId|+1": 1,
          "email|+1": "@email",
          password: "@integer(6, 8",
          "realName|1": ["用户1", "用户2", "用户3", "用户4", "用户5"],
          remark: "@integer(60, 100)",
          "status|1": [1, 2],
          createTime: 1570510990000,
          createUser: 1,
        },
      ],
      totalCount: 20,
      manageUserStatusList: [
        {
          value: "正常",
          key: 1,
        },
        {
          value: "拉黑",
          key: 2,
        },
      ],
    },
  });
}

/**
 *
 */
export async function tablelist() {
  const res = await get("/user/navigation/list");
  return res;

  // return await Mock.mock({
  //   code: 0,
  //   msg: null,
  //   "data|10": [
  //     {
  //       navigationId: 1,
  //       navigationName: "场馆管理",
  //       navigationUrl: "/dashboard/venues",
  //       navigationSequence: 1,
  //       groupId: 1,
  //       parentId: 0,
  //       createTime: 1571378719000,
  //       createUser: 1,
  //       icon: "dollar",
  //       isMenu: 1,
  //       isHave: false,
  //       isParent: null,
  //       have: false,
  //     },
  //   ],
  // });
}

/**
 * 关联权限
 */
export async function relevance(query: any) {
  // const res = await post('/admin/saveNavigation', query)
  // return res
  return await Mock.mock({
    code: 0,
    msg: null,
    data: 10,
  });
}

/**
 * 编辑后台用户
 */
export async function addAdminUser(query: any) {
  // const res = await post('/admin/save', query)
  // return res

  return await Mock.mock({
    code: 0,
    msg: null,
    data: 10,
  });
}

export async function changeAdminUser(id: any, query: any) {
  // const res = await post(`/admin/status/${id}`, query)
  // return res

  return await Mock.mock({
    code: 0,
    msg: null,
    data: 10,
  });
}

/**
 * 更改用户状态
 */
export async function status(query: any) {
  return await Mock.mock({
    code: 0,
    msg: null,
    data: 10,
  });
}
